// 本文件为站点展示用的整理内容，均由公开网络信息汇总而来，仅供参考。

export const heroStats = [
  { label: "收录条目", value: "128", suffix: "条" },
  { label: "热议话题", value: "36", suffix: "个" },
  { label: "资料模块", value: "8", suffix: "块" },
  { label: "更新频率", value: "每日", suffix: "" },
];

export const heroQuickLinks = [
  { label: "个人资料速览", target: "profile", icon: "ri-id-card-line" },
  { label: "最新动态时间线", target: "timeline", icon: "ri-history-line" },
  { label: "社交账号线索", target: "social", icon: "ri-instagram-line" },
  { label: "八卦热议汇总", target: "gossip", icon: "ri-chat-smile-2-line" },
];

export const profileFields = [
  { label: "艺名", value: "夏目彩春" },
  { label: "外文写法", value: "日文写作「夏目彩春」，网络存在不同音译写法" },
  { label: "活动地区", value: "日本" },
  { label: "活跃领域", value: "演艺 / 影像内容" },
  { label: "出道时间", value: "网络说法不一，建议以官方公开为准" },
  { label: "公开平台", value: "Instagram 等社交平台（账号真伪需自行核实）" },
  { label: "资料状态", value: "由公开网络信息整理，持续更新中" },
  { label: "关注热度", value: "中高，讨论主要集中在社交平台" },
];

export const profileParagraphs = [
  "夏目彩春是一位活跃于日本的演艺从业者，网络上关于她的讨论多集中在个人资料、社交账号与近期动态上。本页把她散落在各个平台的公开信息做了归类，方便你一次性浏览，而不必在多个页面之间来回跳转。",
  "需要说明的是，关于她的部分信息在网络上存在多种版本，本页会尽量区分「已经公开确认」和「网传待核实」两类内容。遇到互相矛盾的说法，我们建议以官方网站、官方社交账号发布为准。",
  "如果你只是想快速了解她是谁、近期有什么讨论、社交账号怎么找，可以先看下面的资料速览与动态时间线；如果你更想吃瓜围观，可以直接跳到八卦热议与热搜话题榜两个板块。",
];

export const profileHighlights = [
  {
    icon: "ri-shield-check-line",
    title: "区分真伪",
    desc: "把已公开信息与网传说法分开呈现，减少被误导的可能。",
  },
  {
    icon: "ri-refresh-line",
    title: "持续更新",
    desc: "资料与动态按条目维护，出现新的公开信息会补充进对应板块。",
  },
  {
    icon: "ri-links-line",
    title: "一处看全",
    desc: "资料、动态、账号线索与话题讨论集中在同一页，浏览更省事。",
  },
];

export const timelineItems = [
  {
    date: "2026.10",
    tag: "热度上升",
    title: "相关话题在社交平台讨论增多",
    desc: "近期围绕她的讨论在社交平台出现新一轮增长，话题多集中在资料核实与账号辨别上，具体来源尚待确认。",
    tone: "primary",
  },
  {
    date: "2026.09",
    tag: "资料整理",
    title: "个人资料页补充外文写法说明",
    desc: "由于网络上存在多种音译写法，本页新增了写法说明条目，帮助读者在检索时对齐关键词。",
    tone: "accent",
  },
  {
    date: "2026.08",
    tag: "账号辨别",
    title: "疑似社交账号的讨论明显增加",
    desc: "社交平台上出现若干自称或疑似关联的账号，讨论集中在真伪判断上，本站提示以官方渠道为准。",
    tone: "secondary",
  },
  {
    date: "2026.07",
    tag: "话题回顾",
    title: "早期作品相关话题被重新提及",
    desc: "一些较早的内容被网友重新翻出讨论，形成阶段性话题，热度起伏与平台推荐机制有关。",
    tone: "primary",
  },
  {
    date: "2026.06",
    tag: "信息梳理",
    title: "出道时间的不同说法被集中讨论",
    desc: "关于她出道时间的说法出现多个版本，目前尚无统一结论，建议以官方公开为准。",
    tone: "accent",
  },
  {
    date: "2026.05",
    tag: "关注积累",
    title: "跨平台关注度缓慢累积",
    desc: "关注度呈现缓慢上升的趋势，讨论从单一平台扩散到多个社交渠道。",
    tone: "secondary",
  },
];

export const socialAccounts = [
  {
    platform: "Instagram",
    icon: "ri-instagram-line",
    status: "网传账号较多",
    detail: "网络上流传的说法涉及多个疑似账号，官方身份未获统一确认，建议通过官方渠道核对后再关注。",
    state: "待核实",
  },
  {
    platform: "X（Twitter）",
    icon: "ri-twitter-x-line",
    status: "以公开发布为准",
    detail: "部分讨论提到她在 X 上可能有发布渠道，但目前缺少可确认的官方链接，注意区分同名账号。",
    state: "待核实",
  },
  {
    platform: "TikTok",
    icon: "ri-tiktok-line",
    status: "信息有限",
    detail: "短视频平台上的相关内容多为二次转发或剪辑，是否为她本人运营尚无定论。",
    state: "待核实",
  },
  {
    platform: "YouTube",
    icon: "ri-youtube-line",
    status: "以合集为主",
    detail: "相关频道多为内容合集或搬运性质，判断官方频道时需要结合更新频率与认证标识。",
    state: "待核实",
  },
];

export const socialTips = [
  "优先看平台是否带官方认证标识，认证不等于全部，但能筛掉大部分仿冒账号。",
  "对比粉丝量、注册时间与更新节奏，新注册且短期暴涨的账号要格外谨慎。",
  "不要点击来历不明的外链，尤其是要求登录或填写个人信息的页面。",
  "遇到「独家爆料」「付费内幕」这类说法，先当作营销话术看待，避免冲动付费。",
];

export const gossipCategories = ["全部", "传闻", "热议", "已澄清", "冷知识"];

export const gossipItems = [
  {
    id: 1,
    category: "热议",
    title: "出道时间为何有多个版本",
    summary: "网上流传的出道时间说法不止一个，差异可能来自资料转载时的偏差，目前没有统一定论。",
    date: "2026.10",
    heat: 92,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20rose%20petals%20scattered%20on%20cream%20paper%20with%20warm%20soft%20light%2C%20minimal%20editorial%20still%20life%2C%20elegant%20and%20harmonious%20composition&width=600&height=400&seq=natsume-gossip-05&orientation=landscape",
  },
  {
    id: 2,
    category: "传闻",
    title: "所谓「独家黑料」多数缺少来源",
    summary: "不少所谓黑料贴没有可追溯的来源，内容多为拼接与推测，阅读时建议先看是否有原始出处。",
    date: "2026.09",
    heat: 88,
    image:
      "https://readdy.ai/api/search-image?query=Blurred%20warm%20city%20lights%20at%20dusk%20in%20soft%20pink%20and%20amber%20tones%2C%20dreamy%20bokeh%2C%20artistic%20abstract%20background%2C%20cinematic%20mood&width=600&height=400&seq=natsume-gossip-06&orientation=landscape",
  },
  {
    id: 3,
    category: "热议",
    title: "同名账号扎堆，真假难分",
    summary: "社交平台上与她名字相近的账号数量不少，部分账号借同名蹭流量，关注前建议先做基本核对。",
    date: "2026.09",
    heat: 85,
    image:
      "https://readdy.ai/api/search-image?query=Soft%20silk%20fabric%20folds%20in%20blush%20pink%20and%20cream%20tones%2C%20elegant%20minimal%20texture%20close%20up%2C%20gentle%20lighting%2C%20beautiful%20harmonious%20composition&width=600&height=400&seq=natsume-gossip-07&orientation=landscape",
  },
  {
    id: 4,
    category: "已澄清",
    title: "关于「退圈」的说法缺乏依据",
    summary: "一度流传的退圈说法没有可靠来源支撑，后续也没有官方信息印证，建议按传闻看待。",
    date: "2026.08",
    heat: 74,
    image:
      "https://readdy.ai/api/search-image?query=Calm%20minimal%20desk%20with%20a%20closed%20notebook%20and%20dried%20flowers%2C%20warm%20cream%20background%2C%20soft%20daylight%2C%20quiet%20editorial%20still%20life&width=600&height=400&seq=natsume-gossip-08&orientation=landscape",
  },
  {
    id: 5,
    category: "冷知识",
    title: "名字的中文检索会撞到不少同音词",
    summary: "由于汉字组合特殊，直接检索时容易命中无关结果，加上拉丁写法一起搜命中率会更高。",
    date: "2026.08",
    heat: 61,
    image:
      "https://readdy.ai/api/search-image?query=Open%20book%20pages%20with%20soft%20pink%20bookmark%20on%20a%20cream%20desk%2C%20warm%20reading%20light%2C%20minimal%20editorial%20still%20life%2C%20calm%20and%20refined&width=600&height=400&seq=natsume-gossip-09&orientation=landscape",
  },
  {
    id: 6,
    category: "传闻",
    title: "联动合作的猜测多为粉丝脑补",
    summary: "关于跨界合作的猜测时有出现，但缺少官方预告或正式发布，基本停留在讨论阶段。",
    date: "2026.07",
    heat: 58,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20overlapping%20translucent%20circles%20in%20pink%20gold%20and%20cream%2C%20soft%20gradient%20artistic%20background%2C%20modern%20minimal%20composition&width=600&height=400&seq=natsume-gossip-10&orientation=landscape",
  },
  {
    id: 7,
    category: "热议",
    title: "旧内容被翻出后热度反超新内容",
    summary: "有些较早的内容在二次传播后热度反而更高，这通常和平台推荐与二次剪辑有关。",
    date: "2026.07",
    heat: 55,
    image:
      "https://readdy.ai/api/search-image?query=Vintage%20film%20strip%20curled%20on%20a%20cream%20surface%20with%20warm%20amber%20light%2C%20nostalgic%20minimal%20editorial%20still%20life&width=600&height=400&seq=natsume-gossip-11&orientation=landscape",
  },
  {
    id: 8,
    category: "冷知识",
    title: "不同平台对同一事件描述差异很明显",
    summary: "同一件事在不同平台的描述常有出入，交叉比对两三个来源，比只看一条更靠谱。",
    date: "2026.06",
    heat: 49,
    image:
      "https://readdy.ai/api/search-image?query=Two%20glass%20panes%20reflecting%20different%20warm%20light%20tones%20on%20a%20cream%20wall%2C%20abstract%20minimal%20photography%2C%20soft%20and%20elegant&width=600&height=400&seq=natsume-gossip-12&orientation=landscape",
  },
];

export const rankingTopics = [
  { rank: 1, title: "夏目彩春个人资料整理", heat: 98, tag: "资料" },
  { rank: 2, title: "夏目彩春 ins 账号真假辨别", heat: 94, tag: "账号" },
  { rank: 3, title: "夏目彩春最新动态汇总", heat: 90, tag: "动态" },
  { rank: 4, title: "出道时间的几种说法", heat: 83, tag: "争议" },
  { rank: 5, title: "网络黑料的可信度讨论", heat: 77, tag: "八卦" },
  { rank: 6, title: "不同平台的同名账号盘点", heat: 71, tag: "账号" },
  { rank: 7, title: "旧作翻出后的二次讨论", heat: 64, tag: "动态" },
  { rank: 8, title: "检索她的名字有哪些技巧", heat: 57, tag: "资料" },
];

export const guideSteps = [
  {
    step: "01",
    icon: "ri-search-eye-line",
    title: "先找原始出处",
    desc: "看到一条消息，先看它引用的原始来源是什么。没有出处的，先当作传闻处理。",
  },
  {
    step: "02",
    icon: "ri-links-line",
    title: "交叉比对多个平台",
    desc: "同一件事至少看两到三个来源，描述一致的部分可信度更高，出入大的部分要打问号。",
  },
  {
    step: "03",
    icon: "ri-shield-cross-line",
    title: "警惕营销话术",
    desc: "「独家」「内幕」「付费解锁」这类词往往是引流手段，不要轻易为不确定的信息付费。",
  },
  {
    step: "04",
    icon: "ri-time-line",
    title: "留意发布时间",
    desc: "旧帖被反复转载时容易让人误以为是新动态，注意核对时间戳再判断新鲜度。",
  },
];

export const faqItems = [
  {
    q: "夏目彩春的个人资料可以在哪里确认？",
    a: "建议优先查看官方渠道与有认证标识的社交账号。本站整理的内容来自公开网络，只能作为参考，遇到与官方说法不一致的地方，以官方为准。",
  },
  {
    q: "她的 ins 账号到底哪一个是真的？",
    a: "网络上流传的疑似账号不止一个，目前没有统一确认的官方链接。判断时可以看认证标识、注册时间与更新节奏，避免关注仿冒账号。",
  },
  {
    q: "本站的「八卦黑料」是真实爆料吗？",
    a: "不是。这部分是网络热点话题的汇总与标注，我们会尽量标明哪些是传闻、哪些已被澄清，请勿把网传说法当作已证实的事实。",
  },
  {
    q: "为什么出道时间会有好几种说法？",
    a: "多半是资料转载过程中出现偏差，或不同平台引用了不同的早期来源。在没有官方统一口径前，这些差异只能并存，无法直接判定哪一个准确。",
  },
  {
    q: "内容多久更新一次？",
    a: "资料与动态按条目维护，出现新的公开信息我们会补充到对应板块。热搜话题榜会根据讨论热度做阶段性调整。",
  },
  {
    q: "本站会保存或收集我的信息吗？",
    a: "不会。本站是纯浏览型页面，没有账号系统、也不做数据提交，筛选与切换都只作用在当前页面已有的内容上。",
  },
];

export const navItems = [
  { id: "profile", label: "个人资料" },
  { id: "timeline", label: "最新动态" },
  { id: "social", label: "社交账号" },
  { id: "gossip", label: "八卦热议" },
  { id: "ranking", label: "热搜话题" },
  { id: "faq", label: "常见问题" },
];